<template>
  <div class="container">
    <header id="header" class="utb-header">
      <div class="utb-header-top">
        <a href="/" title="Unite the Bride Home"><img class="utb-logo" src="@/assets/utb-logo.svg" alt="Unite the Bride"></a>
        <div class="utb-nav">
          <a class="menu-trigger button color-gray8"
            :class="{ open: menuExpanded }"
            :aria-expanded="menuExpanded"
            @click="toggleMenu">
            <i class="material-icons md-36" v-if="menuExpanded">close</i>
            <i class="material-icons md-36" v-else>menu</i>
          </a>
          <main-nav :linked="linkedNav"></main-nav>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import MainNav from './ui/MainNav.vue'

export default {
  components: {
    MainNav
  },

  props: {
    linkedNav: false
  },

  data() {
    return {
      menuExpanded: false
    }
  },

  methods: {
    toggleMenu() {
      this.menuExpanded = !this.menuExpanded
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/colors';
@import '~@/styles/media';

.utb-header {
  display: flex;
  justify-content: space-between;
  flex-flow: row auto;
  flex-wrap: wrap;
  margin-top: 1em;
  grid-column: main;

  @include md {
    margin-top: 2em;
    grid-column: main;
  }
}

.utb-header-top {
  width: 100%;

  @include md {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
  }
}

.utb-logo {
  width: 14rem;
  
  @include md {
    width: 15rem;
    padding-right: 1rem;
  }
}

.menu-trigger {
  position: absolute;
  top: 1em;
  right: 2em;
  padding: 0;

  &.open + .nav-bar {
    max-height: 12em;
    opacity: 1;
    transition: 0.5s $easeOutCubic;
  }

  @include md {
    display: none;
  }
}

.nav-bar {
  max-height: 0;
  width: 100%;
  opacity: 0;
  overflow: hidden;
  transition: 0.5s $easeOutCubic;

  @include md {
    max-height: none;
    opacity: 1;
  }
}

.nav-bar ul {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  list-style: none;

  @include md {
    flex-direction: row;
  }
}

.nav-item {
  width: 100%;
  color: map-get($colors, cyan6);
  font-weight: 700;
  font-variant: small-caps;
  text-transform: lowercase;
  letter-spacing: (100/1000) * 1em;
  text-decoration: none;

  &+& {
    border-top: 1px solid map-get($colors, gray3);
  }

  a {
    display: block;
    padding: 0 1em;
    line-height: 3rem;
    color: map-get($colors, gray9);
    text-decoration: none;
    white-space: nowrap;
    background-color: map-get($colors, gray0);
  }

  @include md {
    &+& {
      border-top: none;
      padding-left: 2rem;
    }

    a {
      display: inline-block;
      padding: 0;
      color: map-get($colors, cyan7);
      line-height: 1rem;
      background-color: unset;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue